var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-option',{key:_vm.source.id,attrs:{"label":_vm.source.label||_vm.source.name,"value":_vm.source.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }